@if (!loading && dashcam) {
  <app-breadcrumb
    listado="/main/administracion/dashcams"
    etiquetaListado="Dashcams"
    [titulo]="dashcam ? titulo : undefined"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar">
      <mat-icon>{{ icono }}</mat-icon>
    </div>
    <div class="encabezado-texto">
      <h1>{{ titulo }}</h1>
      @if (subtitulo) {
        <span class="encabezado-nombre">{{ subtitulo }}</span>
      }
      <div class="encabezado-chips">
        @if (cliente) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ cliente }}
          </span>
        }
      </div>
    </div>
    <!-- Mismo permiso que pide el listado para editar -->
    @if (service.puedeEditar()) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar dashcam"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <!-- El orden de las pestañas tiene que coincidir con pestanas() -->
  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-dashcam-info
          [dashcam]="dashcam"
        ></app-detalles-dashcam-info>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">report</mat-icon>
        <span>Alarmas</span>
      </ng-template>
      <ng-template matTabContent>
        <!-- Como en trackers: los eventos de la dashcam sin asignar. Los de
             una dashcam asignada son del activo y se ven en su detalle. -->
        <app-eventos-genericos-historico
          [id]="dashcam._id"
        ></app-eventos-genericos-historico>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">description</mat-icon>
        <span>Reportes</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-reportes-genericos
          [entidad]="dashcam"
          tipoEntidad="Dashcam"
          [tipoValoresReporte]="['Dashcam 4G']"
        ></app-listado-reportes-genericos>
      </ng-template>
    </mat-tab>

    @if (verLogs) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">terminal</mat-icon>
          <span>Logs crudos</span>
        </ng-template>
        <ng-template matTabContent>
          <app-listado-logs-crudos
            [idEntidad]="dashcam._id"
            tipoEntidad="Dashcam"
          ></app-listado-logs-crudos>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
} @else if (loading) {
  <app-detalle-esqueleto
    [icono]="icono"
    listado="/main/administracion/dashcams"
    etiquetaListado="Dashcams"
    [pestanas]="4"
  ></app-detalle-esqueleto>
} @else {
  <app-breadcrumb
    listado="/main/administracion/dashcams"
    etiquetaListado="Dashcams"
    [titulo]="dashcam ? titulo : undefined"
  ></app-breadcrumb>
  <app-empty-state
    [icon]="icono"
    message="No se encontró la dashcam."
  ></app-empty-state>
}
